// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__N6+CO","pageNumber":"style_pageNumber__ievow","pageActive":"style_pageActive__3hCfa"};